<template>
  <div class="flex">
    <div class="flex items-center justify-center">
      <div class="w-12 h-12 rounded-full text-white text-2xl font-bold flex justify-center items-center"
           :class="numberColor">{{ index + 1 }}
      </div>
    </div>
    <div class="ml-3 w-full relative">
      <div class="font-bold text-dark-blue uppercase">{{ data.title }}</div>
      <div class="flex items-center justify-between">
        <div class="relative h-6 mt-1 w-full">
          <div class="bg-gray-50 relative w-full h-full"></div>
          <div class="absolute inset-0 bg-gray-800 rounded-tr-full" :style="[ bgOpacity, width ]"></div>
        </div>
        <div class="bg-gray-50 font-bold text-dark-blue uppercase pr-1 mt-1">{{ data.points }}/6</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChartSingleBar",
  props: {data: Object, index: Number},
  computed: {
    numberColor() {
      if (this.data.points > 5) {
        return "bg-green-500";
      } else if (this.data.points > 3 && this.data.points <= 5) {
        return "bg-yellow-500";
      } else {
        return "bg-red-500";
      }
    },
    bgOpacity() {
      return `--tw-bg-opacity: ${this.data.points / 10 * 2};`
    },
    width() {
      return `width: ${this.data.points / 6 * 100}%;`
    }
  }
}
</script>

<style scoped>

</style>
